import { SIGN_USER_OUT, ADMIN_LOGOUT } from '../actions/actionTypes'
import  { combineReducers } from 'redux'
import productReducer from './productReducer'
import miscReducer from './miscReducer'
import shopReducer from './shopReducer'
import userReducer from './userReducer'
import profileReducer from './profileReducer'
import cartReducer from './cartReducer'
import orderReducer from './orderReducer'
import adminReducer from './adminReducer'
import errorReducer from './errorReducer'


const appReducer = combineReducers({
 products: productReducer,
 misc: miscReducer,
 shop: shopReducer,
 user: userReducer,
 profile: profileReducer,
 cart: cartReducer,
 order: orderReducer,
 admin: adminReducer,
 error: errorReducer
})

const rootReducer = (state, action) => {
  if(action.type === SIGN_USER_OUT)
  state={
    ...state,
    profile: {
      profile: {},
      hasProfile: false
    },
    user: {
      isAuthenticated: false,
      user: {},
      isAdmin: false,
    },
    cart: {
      cart: []
    },
    error: {
      hasErrors: false
    }
  }

  if(action.type === ADMIN_LOGOUT)
  state={
    ...state,
    products: {allClientProducts: []},
    cart: {clientCartData: []},
    order: {orders: []}
  }
  return appReducer(state, action)
}

export default rootReducer